import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './style.css';

const ExternalLinkIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
    <polyline points="15,3 21,3 21,9"/>
    <line x1="10" y1="14" x2="21" y2="3"/>
  </svg>
);

const ProjectCard = ({ title, img, imgBig, index, description, skills, websiteLink, gitHubLink, isPublished = true }) => {
  const { t } = useTranslation('projects');
  const num = String(index + 1).padStart(2, '0');
  const externalLink = isPublished ? (websiteLink || gitHubLink) : null;
  const linkLabel = websiteLink ? t('visitSite') : t('viewGithub');

  return (
    <li className={`proj-card ${index % 3 === 1 ? 'proj-card--offset' : ''}`}>
      <NavLink to={`/project/${index}`} className="proj-card__inner">

        <div className="proj-card__img-wrap">
          <img src={imgBig || img} alt={title} className="proj-card__img" loading="lazy" />
          {!isPublished && (
            <span className="proj-card__badge">{t('comingSoonBadge')}</span>
          )}
          <div className="proj-card__overlay">
            {description && (
              <p className="proj-card__desc">{description}</p>
            )}
            {externalLink && (
              <a
                href={externalLink}
                target="_blank"
                rel="noopener noreferrer"
                className="proj-card__link"
                onClick={e => e.stopPropagation()}
              >
                {linkLabel} <ExternalLinkIcon />
              </a>
            )}
          </div>
        </div>

        <div className="proj-card__footer">
          <span className="proj-card__num">{num}</span>
          <div className="proj-card__meta">
            <h3 className="proj-card__title">{title}</h3>
            {skills && <p className="proj-card__skills">{skills}</p>}
          </div>
        </div>

      </NavLink>
    </li>
  );
};

export default ProjectCard;